var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOscillate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.dev/svgjs",
    viewBox: "0 0 1022 800",
    opacity: 0.51,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "oooscillate-grad"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "hsl(212, 100%, 60%)",
    stopOpacity: 1,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "hsl(237, 48%, 29%)",
    stopOpacity: 1,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.5,
    stroke: "url(#oooscillate-grad)",
    fill: "none",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 608 Q 355.5 170 711 400 Q 1066.5 630 1022 608",
    strokeDasharray: "1 1",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 570 Q 355.5 170 711 400 Q 1066.5 630 1022 570",
    strokeDasharray: "0 1",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 532 Q 355.5 170 711 400 Q 1066.5 630 1022 532",
    strokeDasharray: "1 4",
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 494 Q 355.5 170 711 400 Q 1066.5 630 1022 494",
    strokeDasharray: "1 3",
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 456 Q 355.5 170 711 400 Q 1066.5 630 1022 456",
    strokeDasharray: "1 0",
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 418 Q 355.5 170 711 400 Q 1066.5 630 1022 418",
    strokeDasharray: "0 2",
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 380 Q 355.5 170 711 400 Q 1066.5 630 1022 380",
    strokeDasharray: "5 5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 342 Q 355.5 170 711 400 Q 1066.5 630 1022 342",
    strokeDasharray: "2 1",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 304 Q 355.5 170 711 400 Q 1066.5 630 1022 304",
    strokeDasharray: "2 2",
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 266 Q 355.5 170 711 400 Q 1066.5 630 1022 266",
    strokeDasharray: "4 1",
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 228 Q 355.5 170 711 400 Q 1066.5 630 1022 228",
    strokeDasharray: "2 3",
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 190 Q 355.5 170 711 400 Q 1066.5 630 1022 190",
    strokeDasharray: "4 0",
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 152 Q 355.5 170 711 400 Q 1066.5 630 1022 152",
    strokeDasharray: "3 2",
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 114 Q 355.5 170 711 400 Q 1066.5 630 1022 114",
    strokeDasharray: "4 4",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 76 Q 355.5 170 711 400 Q 1066.5 630 1022 76",
    strokeDasharray: "0 3",
    opacity: 0.54
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOscillate);
export default __webpack_public_path__ + "static/media/oscillate.35aa7e392fc881acd768819bd07febfb.svg";
export { ForwardRef as ReactComponent };